import { useIslands } from "../lib/useIslands";
import { useT } from "../lib/LangContext";

export const IslandSelector = ({ island, onChange, weather = {} }) => {
  const { tIsland } = useT();
  const { islands } = useIslands();
  return (
    <div
      className="w-full border-b border-[#E5E5E5] bg-white"
      data-testid="island-selector"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 overflow-x-auto no-scrollbar">
        <ul className="flex items-center gap-1 sm:gap-3 whitespace-nowrap py-2">
          {islands.map((i) => {
            const active = island === i.slug;
            const wx = i.slug !== "all" ? weather[i.slug] : null;
            const accent = i.color || "#0AADA0";
            return (
              <li key={i.slug} className="flex-shrink-0">
                <button
                  onClick={() => onChange(i.slug)}
                  data-testid={`island-tab-${i.slug}`}
                  className={`relative px-3 sm:px-4 py-2 text-sm transition-colors flex items-center gap-1.5 ${
                    active ? "" : "text-[#6B7280] hover:text-[#1A1A1A]"
                  }`}
                  style={active ? { color: accent } : undefined}
                >
                  <span className="text-[15px]" aria-hidden="true">
                    {i.flag}
                  </span>
                  <span>{tIsland(i.slug) || i.name}</span>
                  {wx && (
                    <span
                      className="ml-0.5 inline-flex items-center gap-0.5 text-[11px] tabular-nums text-[#9CA3AF]"
                      title={`${wx.current.label} · ${wx.city}`}
                      data-testid={`island-tab-weather-${i.slug}`}
                    >
                      <span
                        aria-hidden="true"
                        style={{
                          fontFamily:
                            '"Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji","EmojiOne Color","Twemoji Mozilla",sans-serif',
                        }}
                      >
                        {wx.current.icon}
                      </span>
                      <span>{wx.current.temp}°</span>
                    </span>
                  )}
                  {active && (
                    <span
                      className="absolute left-3 right-3 -bottom-[1px] h-[2px]"
                      style={{ background: accent }}
                    />
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
